import React from "react";
import Modal from "../../Common/Modal/Modal";
import EditTrainingTypeForm from "./EditTrainingTypeForm/EditTrainingTypeForm";

const EditTrainingTypeModal = ({
  editTrainingTypeId,
  editTrainingTypeName,
  handleSearchQuery,
  handleEditModal,
}) => {
  return (
    <Modal
      isOpen={editTrainingTypeId}
      heading={"Edit Training Name"}
      toggle={() => handleEditModal(0)}
      width={"46.2"}
      height={"28.9"}
      justifyContent="normal"
    >
      <EditTrainingTypeForm
        editTrainingTypeId={editTrainingTypeId}
        handleSearchQuery={handleSearchQuery}
        editTrainingTypeName={editTrainingTypeName}
        handleEditModal={handleEditModal}
      />
    </Modal>
  );
};

export default EditTrainingTypeModal;
